module.exports = __webpack_public_path__ + "static/media/close-icon.20c79795.svg";